// TransitionSeries keeps a presentation mounted for the whole clip, pinning progress
// at 0 before the transition and at 1 after it. There is nothing to animate then.
export function isTransitionIdle(
  direction: "entering" | "exiting",
  progress: number,
): boolean {
  return direction === "entering" ? progress >= 1 : progress <= 0;
}
